import {useContext, useState} from 'react';
import {LoginContext, LoginScreen} from './LoginContext';
import {LogInLinkButton} from './SignInButton';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';
import {emailSendAdvice, errorCodeOf} from './emailSendError';

const RESEND_FAILED_MESSAGE = 'Error sending email. Please try again.';

export const EmailSentNotice = ({emailHandler, handlerArgs}) => {
  const [, setLoginState] = useContext(LoginContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const t = useTranslateFunction('miscUI');

  const handleResend = async () => {
    try {
      setError('');
      setLoading(true);
      await emailHandler(...handlerArgs);
      setLoading(false);
    } catch (error) {
      setError(emailSendAdvice(errorCodeOf(error)) ?? RESEND_FAILED_MESSAGE);
      setLoading(false);
    }
  };
  return (
    <div className="d-flex flex-column align-items-center px-2">
      <h3>{t('Email sent!')}</h3>
      <p className="text-center">
        {t(
          "Please check your email for further instructions. If you don't see the email, check your spam folder.",
        )}
      </p>
      <div className="d-flex justify-content-center flex-row">
        <LogInLinkButton
          variant="link"
          onClick={() => setLoginState(LoginScreen.INIT_LANDING)}
        >
          {t('Go back')}
        </LogInLinkButton>
        <LogInLinkButton variant="link" onClick={handleResend}>
          {loading ? t('Loading') : t('Resend email')}
        </LogInLinkButton>
      </div>
      {error && <p style={{color: 'red'}}>{t(error, {forceString: true})}</p>}
    </div>
  );
};
